import styled from 'styled-components';
import './Spinner.css';

type SpinnerProps = {
  text?: string;
};

export const Spinner = ({ text }: SpinnerProps) => {
  return <span className="loader"></span>;
};

export const FullScreenSpinner = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;
